export default "__VITE_ASSET__B4wLP5ek__"